import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GENERIC_ERROR} from '../../constants/ErrorConstants';
import {GET_EVENTS_SUCCESS} from '../../constants/EventsConstants';
import {GetSnapshotMonitorByBookmakerCall} from "../../apis/snapshot";

function* tryFunction(bookmakerId: number) {
    const events: Record<string, string> = yield call(GetSnapshotMonitorByBookmakerCall, bookmakerId);

    yield put({
        type: GET_EVENTS_SUCCESS,
        payload: {events}
    });
}

export function* getEventsSaga({payload}: { payload: number }): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction, payload},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}